import { types } from './actions';

const initialState = {
  isSuperUserChangeUserGroupModalOpen: false,
  isChangingUserGroup: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SUPER_USER_CHANGE_USER_GROUP_MODAL_OPEN:
      return {
        ...state,
        isSuperUserChangeUserGroupModalOpen: true,
      };
    case types.SUPER_USER_CHANGE_USER_GROUP_MODAL_CLOSE:
      return {
        ...state,
        isSuperUserChangeUserGroupModalOpen: false,
      };
    case types.GROUP_MEMBER_CHANGE_USER_GROUP_REQUEST:
      return {
        ...state,
        isChangingUserGroup: true,
      };
    case types.GROUP_MEMBER_CHANGE_USER_GROUP_SUCCESS:
      return {
        ...state,
        isChangingUserGroup: false,
      };
    case types.GROUP_MEMBER_CHANGE_USER_GROUP_ERROR:
      return {
        ...state,
        isChangingUserGroup: false,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.common.userGroupManagement;

export const getIsSuperUserChangeUserGroupModalOpen = (state) =>
  getScope(state).isSuperUserChangeUserGroupModalOpen;

export const getIsChangingUserGroup = (state) =>
  getScope(state).isChangingUserGroup;

export const getIsErrorChangingGroup = (state) =>
  getScope(state).isErrorChangingGroups;
